function toFiniteCoordinate(value) {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && value.trim() !== "" && !Number.isNaN(Number(value))) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

function isValidLatitude(latitude) {
  return latitude != null && latitude >= -90 && latitude <= 90;
}

function isValidLongitude(longitude) {
  return longitude != null && longitude >= -180 && longitude <= 180;
}

/**
 * @param {{ gps_present?: boolean, raw_gps?: { latitude?: unknown, longitude?: unknown } | null } | null | undefined} exifResolutionGps
 * @returns {{ latitude: number, longitude: number } | null}
 */
export function parsePriceHistoryGpsFromExifResolution(exifResolutionGps) {
  if (!exifResolutionGps || exifResolutionGps.gps_present !== true) return null;

  const rawGps = exifResolutionGps.raw_gps;
  if (!rawGps || typeof rawGps !== "object") return null;

  const latitude = toFiniteCoordinate(rawGps.latitude);
  const longitude = toFiniteCoordinate(rawGps.longitude);

  if (!isValidLatitude(latitude) || !isValidLongitude(longitude)) return null;

  return { latitude, longitude };
}

/**
 * @param {{ latitude: number, longitude: number }} coordinates
 */
export function formatGpsCoordinatesLabel({ latitude, longitude }) {
  return `${latitude.toFixed(5)}, ${longitude.toFixed(5)}`;
}

/**
 * @param {{ latitude: number, longitude: number }} coordinates
 */
export function buildGoogleMapsUrlForGps({ latitude, longitude }) {
  return `https://www.google.com/maps?q=${latitude},${longitude}`;
}

/**
 * @param {{ gps_present?: boolean, raw_gps?: { latitude?: unknown, longitude?: unknown } | null } | null | undefined} exifResolutionGps
 * @returns {{ gpsCoordinatesLabel: string, googleMapsUrl: string } | null}
 */
export function buildGpsDisplayFromExifResolution(exifResolutionGps) {
  const coordinates = parsePriceHistoryGpsFromExifResolution(exifResolutionGps);
  if (!coordinates) return null;

  return {
    gpsCoordinatesLabel: formatGpsCoordinatesLabel(coordinates),
    googleMapsUrl: buildGoogleMapsUrlForGps(coordinates),
  };
}
